import '../../../../../types/product.js';
import { isSubscriptionPurchase } from '../../../../../types/typeguards.js';
import { getSelectors } from '../selectors.js';

const { isOneColConfigurator  } = getSelectors();
const hasNullValues = (config)=>Object.values(config).some((value)=>value === null
    )
;
const isColumnValid = (columnState, columnConfigurations)=>{
    if (!columnState.isEnabled) {
        return true;
    }
    if (!hasNullValues(columnConfigurations.prescription)) {
        return true;
    }
    return false;
};
/**
 * The Columns are valid when at least one column is enabled
 * and all enabled columns are completely filled in.
 */ const areColumnsValid = (state)=>{
    if (isOneColConfigurator(state)) {
        return isColumnValid(state.configurator.both, state.configurations.both);
    }
    const isLeftValid = isColumnValid(state.configurator.left, state.configurations.left);
    const isRightValid = isColumnValid(state.configurator.right, state.configurations.right);
    return isLeftValid && isRightValid;
};
const areColumnCheckboxesValid = (state)=>{
    if (isOneColConfigurator(state)) {
        // If there is only one column, the checkboxes are not shown. Consider them always valid
        return true;
    }
    return state.configurator.left.isEnabled || state.configurator.right.isEnabled;
};
const isDeliveryIntervalValid = ({ configurations  })=>{
    const { purchaseType , subscriptionPurchaseConfigurations  } = configurations;
    if (isSubscriptionPurchase(purchaseType)) {
        return subscriptionPurchaseConfigurations.deliveryInterval !== null;
    }
    return undefined;
};
const isQuantityValid = (selectedQuantity, maxSelectableQuantity)=>selectedQuantity <= maxSelectableQuantity
;
const isConfiguratorValid = (state)=>{
    const { columnCheckboxes , columns , deliveryInterval  } = state.configurator;
    const hasInvalid = [
        columnCheckboxes.areValid,
        columns.areValid,
        deliveryInterval.isValid
    ].some((value)=>value === false
    );
    return !hasInvalid;
};

export { areColumnCheckboxesValid, areColumnsValid, isColumnValid, isConfiguratorValid, isDeliveryIntervalValid, isQuantityValid };
//# sourceMappingURL=state-helpers.js.map
